<!-- page-not-found.component.html -->
<div class="container">
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you're looking for doesn't exist or has been removed.</p>
    <a routerLink="/">Back to Home</a>
  </div>
  